import Container from '../../../elements/Container'
import Section from '../../../elements/Section'
import styles from './styles.module.scss'
import { useState, useRef, useEffect } from 'react'
import Button from '../../../elements/Button'
import { CSSTransition } from 'react-transition-group'
import { withModifiers } from '../../../helpers/withModifiers'
import dynamic from 'next/dynamic'
const CloudflareVideo = dynamic(
  () => import('../../../elements/CloudflareVideo'),
  {
    ssr: false
  }
)

const Welcome = ({ video, title, subtitle, button }) => {
  const [play, setPlay] = useState(false)
  const [minutes, setMinutes] = useState(false)
  const [ready, setReady] = useState(false)
  const [seconds, setSeconds] = useState(false)
  const ref = useRef(null)

  const onVideoLoaded = () => {
    let total = ref.current.duration
    let mins = Math.floor(total / 60)
    let secs = Math.floor(total - mins * 60)
    setMinutes(mins)
    setSeconds(secs)
    setReady(true)
  }

  useEffect(() => {
    play && ref.current.play()
  }, [play])

  return (
    <Section variant={['center', 'pb0']}>
      <Container>
        <div className={styles.intro}>
          {title && <h1 className={styles.intro__title}>{title}</h1>}

          {subtitle && <div className={styles.intro__subtitle}>{subtitle}</div>}

          <div className={styles.intro__video}>
            <div
              className={withModifiers(
                'intro__mask',
                [ready && 'hidden'],
                styles
              )}
            ></div>

            {video && (
              <CloudflareVideo
                controls={play}
                playing={play}
                src={video}
                streamRef={ref}
                onCanPlay={onVideoLoaded}
              />
            )}

            {button && !play && (
              <CSSTransition
                classNames="opacity"
                appear={true}
                timeout={{ enter: 200, exit: 200 }}
                key={play}
              >
                <Button
                  arrow={false}
                  variant={['primary-blue']}
                  onClick={() => setPlay(true)}
                  className={styles.intro__trigger}
                >
                  {button}
                  <span>{`[${minutes}:${
                    seconds === 0 ? '00' : seconds
                  }]`}</span>
                </Button>
              </CSSTransition>
            )}
          </div>
        </div>
      </Container>
    </Section>
  )
}

export default Welcome
